// Copyright ©️ 2026 eVolve MEP, LLC

import { Title } from '@mantine/core';

import { FacilityPropertiesForm, type FacilityPropertiesFormProps } from './FacilityPropertiesForm';

export const FacilityDetailsPane = (props: FacilityPropertiesFormProps) => (
  <>
    <Title order={3}>Properties</Title>
    <FacilityPropertiesForm {...props} />
  </>
);
